/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Divider, Grid, makeStyles, Tooltip } from '@material-ui/core';
import Cancel from '@material-ui/icons/Cancel';
import CheckCircle from '@material-ui/icons/CheckCircle';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import _ from 'lodash';
import { selectCompany, selectPartner } from 'modules/authenticate/actions';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import Permission from 'components/ValidPermission';
import {
  getAllClientsRequest,
  handleRemoveClientRequest,
} from 'modules/clients/actions';
import { ListClientDataProps } from 'modules/clients/interfaces';
import {
  getAllUserCompanyRequest,
  getCompanyRequest,
} from 'modules/companies/actions';
import {
  CompanyFields,
  UserCompanyListDataProps,
} from 'modules/companies/interfaces';
import {
  getAllEnvironmentsRequest,
  removeEnvironmentRequest,
} from 'modules/environments/actions';
import { ListEnvironmentDataProps } from 'modules/environments/interfaces';
import {
  deletePartnerRequest,
  getAllPartnersRequest,
} from 'modules/partners/actions';
import { ListPartnerDataProps } from 'modules/partners/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import Button from 'components/Button';
import Loading from 'components/Loading';
import { getCompanyName } from 'utils/tsHelpers';
import { useTableFilters } from 'hooks/useTableFilters';
import CompanyCard from './CompanyCard';
import TabsCompany, { TableTab } from '../TabsCompany';
import styles from './styles';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 6,
  search: '',
};

interface Props {
  isLoading: boolean;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  company: CompanyFields | null;
  partnerList: ListPartnerDataProps;
  usersCompanyList: UserCompanyListDataProps;
  environmentList: ListEnvironmentDataProps;
  clientList: ListClientDataProps;
  getCompanyRequest: (id: string) => void;
  getAllPartnersRequest: (props) => void;
  getAllEnvironmentsRequest: (props) => void;
  getAllClientsRequest: (props) => void;
  getAllUserCompanyRequest: (props) => void;
  deletePartnerRequest: ({ query, partnerUuid, company_uuid }) => void;
  handleRemoveClientRequest: ({ query, clientUuid }) => void;
  removeEnvironmentRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  selectCompany: (company: CompanyData | null) => void;
  selectPartner: (partner: PartnerData | null) => void;
}

const EditCompany = ({
  isLoading,
  company,
  partnerList,
  environmentList,
  companySelected,
  partnerSelected,
  clientList,
  usersCompanyList,
  getCompanyRequest,
  getAllPartnersRequest,
  getAllEnvironmentsRequest,
  getAllClientsRequest,
  deletePartnerRequest,
  handleRemoveClientRequest,
  modalOpen,
  modalClose,
  removeEnvironmentRequest,
  selectCompany,
  selectPartner,
  getAllUserCompanyRequest,
}: Props) => {
  const classes = useStyles();
  const {
    query,
    handleLimitChange,
    handlePageChange,
    setQuery,
  } = useTableFilters(initialQuery);
  const [currentTab, setCurrentTab] = React.useState(0);
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [order, setOrder] = React.useState(false);

  const makeStatus = {
    active: (
      <Tooltip placement="top" arrow title={i18n.t('ACTIVE_KEY')}>
        <CheckCircle className={classes.iconActive} />
      </Tooltip>
    ),
    blocked: (
      <Tooltip placement="top" arrow title={i18n.t('BLOCK_KEY')}>
        <Cancel className={classes.iconCancel} />
      </Tooltip>
    ),
  };

  const makeFields = (items: Array<any>, fields: Array<string>) =>
    items.map(item =>
      fields.map(field => {
        let value = _(item).get(field);

        if (field === 'active') {
          value = makeStatus[field];
        }

        if (typeof value === 'boolean')
          value = i18n.t(value ? 'YES_KEY' : 'NO_KEY');

        return value;
      })
    );

  const getDataTable = (key: number) => {
    const mapGetData = {
      0: () => getAllPartnersRequest({ query, company_uuid: id }),
      1: () => getAllEnvironmentsRequest({ ...query, company_uuid: id }),
      2: () => getAllClientsRequest({ ...query, company_uuid: id }),
      3: () => getAllUserCompanyRequest({ query, company_uuid: id }),
    };

    return mapGetData[key]();
  };

  const handleRemoveEnvironment = item => {
    modalOpen({
      title: `${i18n.t('REMOVE_KEY')} ${item.name}`,
      content: i18n.t('ENVIRONMENTS_PAGE.REMOVE_DESCRIPTION_KEY'),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              removeEnvironmentRequest({
                environmentUuid: item?.environment_uuid,
                ...query,
                company_uuid: companySelected?.id,
                partner_uuid: partnerSelected?.id,
              });
              modalClose();
            }}
          >
            {i18n.t('REMOVE_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  React.useEffect(() => {
    getCompanyRequest(id);
    getDataTable(0);
  }, [id, getCompanyRequest]);

  React.useEffect(() => {
    getDataTable(currentTab);
  }, [query, currentTab]);

  const handleOrder = (tab, key) => {
    setQuery(prev => ({
      ...prev,
      ordering: `${order ? '-' : ''}${key}`,
    }));
    setOrder(!order);
    getDataTable(tab);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageTitle
          title={i18n.t('COMPANIES_PAGE.DETAILS_COMPANY_TITLE_KEY')}
          subtitle={i18n.t('COMPANIES_PAGE.DETAILS_COMPANY_SUBTITLE_KEY')}
        />
      </Grid>
      <Grid container className={classes.detailsContainer}>
        {!isLoading ? <CompanyCard company={company} /> : <Loading />}
      </Grid>

      <Divider className={classes.divider} />

      <Grid item xs={12} className={classes.wrapTitle}>
        <PageTitle
          title={i18n.t('COMPANIES_PAGE.CONSULT_COMPANY_TITLE_KEY')}
          subtitle={i18n.t('COMPANIES_PAGE.CONSULT_COMPANY_SUBTITLE_KEY', {
            name: getCompanyName(company),
          })}
        />
      </Grid>
      <TabsCompany
        permissionTab={{ key: 'list_company_users', indexTab: 3 }}
        onChange={(event, currentTab) => setCurrentTab(currentTab)}
        labels={[
          i18n.t('PARTNERS_KEY'),
          i18n.t('ENVIRONMENTS_KEY'),
          i18n.t('CLIENTS_KEY'),
          i18n.t('USERS_KEY'),
        ]}
        panels={[
          <TableTab
            key="table-parceiro"
            getItemToOrder={value => handleOrder(0, value)}
            labels={[
              { key: 'name', title: i18n.t('PARTNER_NAME_KEY') },
              { key: 'alias', title: i18n.t('ALIAS_KEY') },
              { key: 'ldap_type', title: 'LDAP', align: true },
              {
                key: 'new_front',
                title: i18n.t('USE_FRONT_KEY'),
                align: true,
              },
            ]}
            fields={makeFields(partnerList.results, [
              'name',
              'alias',
              'active_directory.ldap_type',
              'frontend.enable_new_interface',
            ])}
            items={partnerList.results}
            count={partnerList.count}
            rowsPerPage={query.limit}
            onChangePage={page => handlePageChange(page)}
            onChangeLimit={limit => handleLimitChange(limit)}
            handleEdit={({ partner_uuid }) =>
              history.push(`/partners/${partner_uuid}/configuration`)
            }
            handleRemove={({ partner_uuid, name }) =>
              modalOpen({
                title: i18n.t('PARTNER_PAGE.REMOVE_PARTNER_KEY'),
                content: i18n.t('PARTNER_PAGE.REMOVE_PARTNER_DESCRIPTION_KEY', {
                  name,
                }),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="submit-button"
                      onClick={() => {
                        deletePartnerRequest({
                          query,
                          partnerUuid: partner_uuid,
                          company_uuid: id,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              })
            }
          />,

          <TableTab
            key="table-ambientes"
            getItemToOrder={value => handleOrder(1, value)}
            labels={[
              {
                key: 'name',
                title: i18n.t('ENVIRONMENT_NAME_KEY'),
              },
              { key: 'partner', title: i18n.t('PARTNER_KEY') },
              {
                key: 'cloud_provider',
                title: i18n.t('PROVIDER_CLOUD_KEY'),
                align: true,
              },
              {
                key: 'license_limit',
                title: i18n.t('TOTAL_LICENSES_KEY'),
                align: true,
              },
            ]}
            fields={makeFields(environmentList.results, [
              'name',
              'partner.name',
              'provider.type',
              'licenses.license_limit',
            ])}
            items={environmentList.results}
            count={environmentList.count}
            rowsPerPage={query.limit}
            onChangePage={page => handlePageChange(page)}
            onChangeLimit={limit => handleLimitChange(limit)}
            handleEdit={({ environment_uuid, partner }) => {
              selectCompany({
                name: getCompanyName(company)!,
                id: company?.company_uuid!,
                shortName: getCompanyName(company)!,
              });
              selectPartner({
                name: partner.name,
                shortName: partner.name,
                id: partner.partner_uuid,
              });
              history.push(`/environments/${environment_uuid}/configuration`);
            }}
            handleRemove={item => handleRemoveEnvironment(item)}
          />,

          <TableTab
            key="table-clientes"
            getItemToOrder={value => handleOrder(2, value)}
            labels={[
              { key: 'name', title: i18n.t('CLIENT_NAME_KEY') },
              {
                key: 'environment',
                title: i18n.t('ENVIRONMENT_NAME_KEY'),
              },
              { key: 'partner', title: i18n.t('PARTNER_KEY') },
            ]}
            fields={makeFields(clientList.results, [
              'name',
              'environment.name',
              'partner.name',
            ])}
            items={clientList.results}
            count={clientList.count}
            rowsPerPage={query.limit}
            onChangePage={page => handlePageChange(page)}
            onChangeLimit={limit => handleLimitChange(limit)}
            handleEdit={item => {
              selectCompany({
                name: getCompanyName(company)!,
                id: company?.company_uuid!,
                shortName: getCompanyName(company)!,
              });
              selectPartner({
                name: item.partner.name,
                shortName: item.partner.name,
                id: item.partner.partner_uuid,
              });
              history.push(`/clients/${item.client_uuid}/configurations`);
            }}
            handleRemove={({ client_uuid, name }) =>
              modalOpen({
                title: i18n.t('CLIENTS_PAGE.REMOVE_CLIENT_KEY'),
                content: i18n.t('CLIENTS_PAGE.REMOVE_CLIENT_DESCRIPTION_KEY', {
                  name,
                }),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="submit-button"
                      onClick={() => {
                        handleRemoveClientRequest({
                          query: {
                            ...query,
                            company_uuid: id,
                          },
                          clientUuid: client_uuid,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              })
            }
          />,
          <Permission key="table-usuer" value="list_company_users">
            <TableTab
              getItemToOrder={value => handleOrder(3, value)}
              key="table-usuer"
              labels={[
                { key: 'first_name', title: i18n.t('NAME_KEY') },
                {
                  key: 'last_name',
                  title: i18n.t('LAST_NAME_KEY'),
                },
                { key: 'email', title: i18n.t('EMAIL_KEY') },
                { key: 'client_name', title: i18n.t('CLIENT_KEY') },
              ]}
              fields={makeFields(usersCompanyList.results, [
                'first_name',
                'last_name',
                'email',
                'client_name',
              ])}
              items={usersCompanyList.results}
              count={usersCompanyList.count}
              rowsPerPage={query.limit}
              onChangePage={page => handlePageChange(page)}
              onChangeLimit={limit => handleLimitChange(limit)}
              noAction
            />
          </Permission>,
        ]}
      />
    </Grid>
  );
};

const mapStateToProps = ({
  companies: { isLoading, companyDetails, usersCompanyList },
  partners: { partnerList },
  environments: { environmentList },
  authenticate: { companySelected, partnerSelected },
  clients: { clientList },
}: ApplicationState) => ({
  isLoading,
  company: companyDetails,
  partnerList,
  companySelected,
  partnerSelected,
  environmentList,
  clientList,
  usersCompanyList,
});

export default connect(mapStateToProps, {
  getCompanyRequest,
  getAllPartnersRequest,
  getAllEnvironmentsRequest,
  getAllClientsRequest,
  deletePartnerRequest,
  handleRemoveClientRequest,
  removeEnvironmentRequest,
  selectCompany,
  selectPartner,
  getAllUserCompanyRequest,
  modalOpen,
  modalClose,
})(EditCompany);
